
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/ev-rebates",
      function () {
        return require("private-next-pages/evcharging/ev-rebates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/ev-rebates"])
      });
    }
  